// extracted by css-extract-rspack-plugin
export default {"icon":"icon-deKQ7L","alternateFill":"alternateFill-V26FbP"};